var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 12.9999V14.0416C10.5003 14.3868 10.2205 14.6666 9.87533 14.6666H2.79199C2.44681 14.6666 2.16699 14.3868 2.16699 14.0416V4.45825C2.16699 4.11307 2.44681 3.83325 2.79199 3.83325H4.66699V11.5416C4.66699 12.3457 5.32119 12.9999 6.12533 12.9999H10.5003ZM10.5003 4.04159V1.33325H6.12533C5.78014 1.33325 5.50033 1.61307 5.50033 1.95825V11.5416C5.50033 11.8868 5.78014 12.1666 6.12533 12.1666H13.2087C13.5538 12.1666 13.8337 11.8868 13.8337 11.5416V4.66659H11.1253C10.7816 4.66659 10.5003 4.38534 10.5003 4.04159ZM13.6506 3.23354L11.9334 1.5163C11.8162 1.3991 11.6572 1.33325 11.4914 1.33325H11.3337V3.83325H13.8337V3.67547C13.8337 3.50971 13.7678 3.35075 13.6506 3.23354Z",
    fill: "#454B5C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.091eeec3.svg";
export { ForwardRef as ReactComponent };